// this is a test value for development, this will later include custom user settings.
// in the future this data will come from the server
// and will be hydrated into the reducer.

export default {
    draftID: null,
    userID: null,
    email: 'john_doe@bananatag.com',
    preferences: {}, // in the future this will hold colors, fonts, ..
};
